import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as userActions from "app/Core/Funcionalidade/Auth/store/actions";
import * as ComunicadorActions from "app/Core/Funcionalidade/Comunicador/Store/Actions/ComunicadorActions";
import * as AppActions from "app/store/actions";
import * as Actions from "./Store/Actions/PagamentoActions";
import _ from "lodash";
import withReducer from 'app/store/withReducer';
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PagamentoDialog from "./PagamentoDialog";
import reducer from "./Store/Reducers/PagamentoReducer"
import clsx from "clsx";

class Pagamento extends XAPPComponent {

  state = {
    openDialog: null
  };

  componentDidMount() {
    this.checkExistsAlert();
  }

  componentDidUpdate() {
    if (this.props.Pagamento.error) {
      this.props.showMessage({
        message: this.props.Pagamento.error,
        variant: "error"
      });
      this.props.Pagamento.error = null;
    }
    if (this.props.Pagamento.warning) {
      this.props.showMessage({
        message: this.props.Pagamento.warning,
        variant: "warning"
      });
      this.props.Pagamento.warning = null;
    }
    if (this.props.Pagamento.info) {
      this.props.showMessage({
        message: this.props.Pagamento.info,
        variant: "success"
      });
      this.props.Pagamento.info = null;
    }
  }

  checkExistsAlert = () => {
    const { statusXapp = null } = this.props;
    if (!_.isNull(statusXapp) && Object.keys(statusXapp).length > 0) {
      Object.keys(statusXapp).forEach(key => {
        if (statusXapp[key].autoopen) {
          this.changeOpenDialog(key);
        }
      });
    }
  }

  changeOpenDialog = (_AValue = null) => {
    this.setState(_.set({ ...this.state }, "openDialog", _AValue));
    this.props.clearReducer();
  };

  render() {
    const { statusXapp = null, user, empresa, save, verificarPagamento, Pagamento, chave = null, children = null, className = null } = this.props;
    const { openDialog } = this.state;
    return (
      <React.Fragment>
        {!_.isNull(children) && !_.isNull(chave) &&
          <div className={clsx(!_.isNull(className) ? className : "w-fit", "cursor-pointer")} onClick={() => this.changeOpenDialog(chave)}>
            {children}
          </div>
        }
        {!_.isNull(statusXapp) && Object.keys(statusXapp).length > 0 &&
          <PagamentoDialog
            open={!_.isNull(openDialog)}
            openDialog={this.changeOpenDialog}
            chave={openDialog}
            data={statusXapp[openDialog]}
            user={user}
            xappRouteParams={{ "empresa": empresa }}
            save={save}
            verificarPagamento={verificarPagamento}
            Pagamento={Pagamento}
          />
        }
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      save: Actions.save,
      verificarPagamento: Actions.verificarPagamento,
      clearReducer: Actions.clearReducer,
      addAppMessage: ComunicadorActions.addAppMessage,
      showMessage: AppActions.showMessage,
      setNavigation: AppActions.setNavigation,
      setOrganizacoes: userActions.setOrganizacoes,
    },
    dispatch
  );
}

function mapStateToProps({ Pagamento, fuse, auth }) {
  return {
    Pagamento: Pagamento,
    empresa: fuse.navigation.empresa,
    theme: fuse.settings.mainTheme,
    statusXapp: auth.user.statusXapp,
    user: auth.user.data,
  };
}

export default withReducer('Pagamento', reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Pagamento)));
